export enum EstadosBrasil {
  AC = 'Acre',
  AL = 'Alagoas',
  AP = 'Amapá',
  AM = 'Amazonas',
  BA = 'Bahia',
  CE = 'Ceará',
  DF = 'Distrito Federal',
  ES = 'Espírito Santo',
  GO = 'Goiás',
  MA = 'Maranhão',
  MT = 'Mato Grosso',
  MS = 'Mato Grosso do Sul',
  MG = 'Minas Gerais',
  PA = 'Pará',
  PB = 'Paraíba',
  PR = 'Paraná',
  PE = 'Pernambuco',
  PI = 'Piauí',
  RJ = 'Rio de Janeiro',
  RN = 'Rio Grande do Norte',
  RS = 'Rio Grande do Sul',
  RO = 'Rondônia',
  RR = 'Roraima',
  SC = 'Santa Catarina',
  SP = 'São Paulo',
  SE = 'Sergipe',
  TO = 'Tocantins',
}

export const NomesEstadosBrasil = new Map<EstadosBrasil, string>([
  [EstadosBrasil.AC, 'Acre'],
  [EstadosBrasil.AL, 'Alagoas'],
  [EstadosBrasil.AP, 'Amapá'],
  [EstadosBrasil.AM, 'Amazonas'],
  [EstadosBrasil.BA, 'Bahia'],
  [EstadosBrasil.CE, 'Ceará'],
  [EstadosBrasil.DF, 'Distrito Federal'],
  [EstadosBrasil.ES, 'Espírito Santo'],
  [EstadosBrasil.GO, 'Goiás'],
  [EstadosBrasil.MA, 'Maranhão'],
  [EstadosBrasil.MT, 'Mato Grosso'],
  [EstadosBrasil.MS, 'Mato Grosso do Sul'],
  [EstadosBrasil.MG, 'Minas Gerais'],
  [EstadosBrasil.PA, 'Pará'],
  [EstadosBrasil.PB, 'Paraíba'],
  [EstadosBrasil.PR, 'Paraná'],
  [EstadosBrasil.PE, 'Pernambuco'],
  [EstadosBrasil.PI, 'Piauí'],
  [EstadosBrasil.RJ, 'Rio de Janeiro'],
  [EstadosBrasil.RN, 'Rio Grande do Norte'],
  [EstadosBrasil.RS, 'Rio Grande do Sul'],
  [EstadosBrasil.RO, 'Rondônia'],
  [EstadosBrasil.RR, 'Roraima'],
  [EstadosBrasil.SC, 'Santa Catarina'],
  [EstadosBrasil.SP, 'São Paulo'],
  [EstadosBrasil.SE, 'Sergipe'],
  [EstadosBrasil.TO, 'Tocantins']
]);

export const SiglaEstadosBrasil = new Map<EstadosBrasil, string>([
  [EstadosBrasil.AC, 'AC'],
  [EstadosBrasil.AL, 'AL'],
  [EstadosBrasil.AP, 'AP'],
  [EstadosBrasil.AM, 'AM'],
  [EstadosBrasil.BA, 'BA'],
  [EstadosBrasil.CE, 'CE'],
  [EstadosBrasil.DF, 'DF'],
  [EstadosBrasil.ES, 'ES'],
  [EstadosBrasil.GO, 'GO'],
  [EstadosBrasil.MA, 'MA'],
  [EstadosBrasil.MT, 'MT'],
  [EstadosBrasil.MS, 'MS'],
  [EstadosBrasil.MG, 'MG'],
  [EstadosBrasil.PA, 'PA'],
  [EstadosBrasil.PB, 'PB'],
  [EstadosBrasil.PR, 'PR'],
  [EstadosBrasil.PE, 'PE'],
  [EstadosBrasil.PI, 'PI'],
  [EstadosBrasil.RJ, 'RJ'],
  [EstadosBrasil.RN, 'RN'],
  [EstadosBrasil.RS, 'RS'],
  [EstadosBrasil.RO, 'RO'],
  [EstadosBrasil.RR, 'RR'],
  [EstadosBrasil.SC, 'SC'],
  [EstadosBrasil.SP, 'SP'],
  [EstadosBrasil.SE, 'SE'],
  [EstadosBrasil.TO, 'TO']
]);
